export const LOGOUT_CHANNEL_NAME = "datacleaning-logout-channel";
export const LOGOUT_MESSAGE_TYPE = "LOGOUT";

const createLogoutChannel = (): BroadcastChannel | null => {
  if (typeof BroadcastChannel === "undefined") {
    return null;
  }

  return new BroadcastChannel(LOGOUT_CHANNEL_NAME);
};

export const broadcastLogout = (): void => {
  const channel = createLogoutChannel();
  if (!channel) {
    return;
  }

  channel.postMessage({ type: LOGOUT_MESSAGE_TYPE });
  channel.close();
};

export const subscribeToLogout = (onLogout: () => void): (() => void) => {
  const channel = createLogoutChannel();
  if (!channel) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {};
  }

  const handleMessage = ({ data }: MessageEvent): void => {
    if (data?.type === LOGOUT_MESSAGE_TYPE) {
      onLogout();
    }
  };

  channel.addEventListener("message", handleMessage);

  return () => {
    channel.removeEventListener("message", handleMessage);
    channel.close();
  };
};
